import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {
  UserAccessPageContainerComponent,
} from './components/user-access-page-container/user-access-page-container.component';

const routes: Routes = [
  {
    path: '',
    component: UserAccessPageContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserAccessPageRoutingModule {
}
